// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.SpaceView_header__pIFVo {
  font-weight: bold;
}

.SpaceView_subHeader__XRml6 {
  font-size: 0.8rem;
}

.SpaceView_spaceImages__container__AHTQj {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.SpaceView_spaceImages__container__AHTQj div {
  height: 100px;
  width: 150px;
  border: 5px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.SpaceView_spaceImages__container__AHTQj div img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: 0.2s linear;
  cursor: pointer;
}
.SpaceView_spaceImages__container__AHTQj div img:hover {
  transform: scale(1.1);
}

.SpaceView_spaceVideo__W\\+je1 {
  margin-top: 1rem;
}
.SpaceView_spaceVideo__video__qgHQU {
  height: 100px;
  width: 150px;
  overflow: hidden;
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  cursor: pointer;
}
.SpaceView_spaceVideo__video__qgHQU video {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: 0.2s linear;
}
.SpaceView_spaceVideo__video__qgHQU video:hover {
  transform: scale(1.1);
}

.SpaceView_features__qCwTp {
  margin-top: 1rem;
}
.SpaceView_features__container__ex4CP {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.SpaceView_features__centerCard__-wQKT {
  border: 2px solid #545cd8;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}
.SpaceView_features__centerCard__-wQKT p {
  margin: 0;
  color: #545cd8;
}
.SpaceView_features__card__g9w7H {
  border: 2px solid #545cd8;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  gap: 0.5rem;
}
.SpaceView_features__card__g9w7H p {
  margin: 0;
  color: #545cd8;
}

.SpaceView_spaceActions__container__I6X4I {
  justify-content: end;
  margin-top: 10px;
}
.SpaceView_spaceActions__container__actions__p0fWU {
  display: flex;
  justify-content: end;
  align-items: center;
}
.SpaceView_spaceActions__container__actions__action__Am2LE {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Spaces/styles/SpaceView.module.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;AACJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AAEI;EACI,aAAA;EACA,eAAA;EACA,SAAA;AACR;AACQ;EACI,aAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;AACZ;AACY;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;AAChB;AACgB;EACI,qBAAA;AACpB;;AAMA;EACI,gBAAA;AAHJ;AAII;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;AAFR;AAIQ;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AAFZ;AAIY;EACI,qBAAA;AAFhB;;AAQA;EACI,gBAAA;AALJ;AAMI;EACI,aAAA;EACA,eAAA;EACA,SAAA;AAJR;AAOI;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AALR;AAOQ;EACI,SAAA;EACA,cAAA;AALZ;AASI;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AAPR;AASQ;EACI,SAAA;EACA,cAAA;AAPZ;;AAaI;EACI,oBAAA;EACA,gBAAA;AAVR;AAWQ;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;AATZ;AAUY;EACI,iBAAA;AARhB","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n.header {\n    font-weight: bold;\n}\n\n.subHeader {\n    font-size: 0.8rem;\n}\n\n.spaceImages {\n    &__container {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 1rem;\n\n        div {\n            height: 100px;\n            width: 150px;\n            border: 5px solid rgba(0, 0, 0, 0.1);\n            overflow: hidden;\n\n            img {\n                height: 100%;\n                width: 100%;\n                object-fit: cover;\n                transition: 0.2s linear;\n                cursor: pointer;\n\n                &:hover {\n                    transform: scale(1.1);\n                }\n            }\n        }\n    }\n}\n\n.spaceVideo {\n    margin-top: 1rem;\n    &__video {\n        height: 100px;\n        width: 150px;\n        overflow: hidden;\n        border: 5px solid rgba(0, 0, 0, 0.1);\n        border-radius: 5px;\n        cursor: pointer;\n\n        video {\n            height: 100%;\n            width: 100%;\n            object-fit: cover;\n            transition: 0.2s linear;\n\n            &:hover {\n                transform: scale(1.1);\n            }\n        }\n    }\n}\n\n.features {\n    margin-top: 1rem;\n    &__container {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 1rem;\n    }\n\n    &__centerCard {\n        border: 2px solid #545cd8;\n        border-radius: 5px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 1rem;\n\n        p {\n            margin: 0;\n            color: #545cd8;\n        }\n    }\n\n    &__card {\n        border: 2px solid #545cd8;\n        border-radius: 5px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 1rem;\n        gap: 0.5rem;\n\n        p {\n            margin: 0;\n            color: #545cd8;\n        }\n    }\n}\n\n.spaceActions {\n    &__container {\n        justify-content: end;\n        margin-top:10px;\n        &__actions {\n            display: flex;\n            justify-content: end;\n            align-items: center;\n            &__action {\n                margin-left: 10px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `SpaceView_header__pIFVo`,
	"subHeader": `SpaceView_subHeader__XRml6`,
	"spaceImages__container": `SpaceView_spaceImages__container__AHTQj`,
	"spaceVideo": `SpaceView_spaceVideo__W+je1`,
	"spaceVideo__video": `SpaceView_spaceVideo__video__qgHQU`,
	"features": `SpaceView_features__qCwTp`,
	"features__container": `SpaceView_features__container__ex4CP`,
	"features__centerCard": `SpaceView_features__centerCard__-wQKT`,
	"features__card": `SpaceView_features__card__g9w7H`,
	"spaceActions__container": `SpaceView_spaceActions__container__I6X4I`,
	"spaceActions__container__actions": `SpaceView_spaceActions__container__actions__p0fWU`,
	"spaceActions__container__actions__action": `SpaceView_spaceActions__container__actions__action__Am2LE`
};
export default ___CSS_LOADER_EXPORT___;
